import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { rMadenSahalariBilgi } from '../../../../api/models/.catalog';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';

export default ApiBaseReducer<
  pList,
  IInputDataStateModel<pList, rMadenSahalariBilgi>,
  rMadenSahalariBilgi
>(ActionSubTypes.API_MADENSAHALARIBILGI, DefaultInputDataStateModel<pList, rMadenSahalariBilgi>());
